import React, { FC, useEffect, useState } from "react";
import ViewEnhancementIhx from "../../../../components/patient/Enhancement/IHX/ViewEnhancementIhx";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  downloadDocument,
  enhancementServiceIhx,
  getAllStarhealthDocumentsData,
} from "../../../../apis/patientService";
import { message } from "antd";
import { errorMessage } from "../../../../utils/notificationUtils";
import { getDeficiencyQuestionData } from "../../../../models/patientSlice";
import ViewEnhancementDocumentIhx from "../../../../components/patient/Enhancement/IHX/ViewEnhancementDocumentIhx";
import { enhancementServiceCghs, fetchEnhancementDataServiceCghs } from "../../../../apis/SchemeService/CGHS/cghsService";
import ViewEnhancementDocumentCghs from "../../../../components/patient/Enhancement/CGHS/ViewEnhancementDocumentCghs";
import ViewEnhancementCghs from "../../../../components/patient/Enhancement/CGHS/ViewEnhancementCghs";

type ViewEnhancementContainerCghsProps = {
  closeViewAddedEnhancement: any;
  viewEnhancement: boolean;
};

const ViewEnhancementContainerCghs: FC<ViewEnhancementContainerCghsProps> = ({
  viewEnhancement,
  closeViewAddedEnhancement,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients } = useSelector((state: RootState) => state);
  const [enhancementData, setEnhancementData] = useState<any>([]);
  const [isFetchingEnhancementData, setIsFetchingEnhancementData] =
    useState<boolean>(false);
  const [documentName, setDocumentName] = useState("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);

  const handleOpen = (documentList: any, docType: any) => {
    setPreviewDocument(true);
    setDocumentUrls(documentList);
    setClickedActiveTab(docType);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );

        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any
  ) => {
    await fetchDeficiencyData(document, document?.id);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

//   const fetchData = async () => {
//     try {
//       if (
//         patients?.fetchBasicDetails?.casesResponse?.id &&
//         patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds &&
//         patients?.fetchBasicDetails?.visitInfoResponse?.id
//       ) {
//         setIsFetchingEnhancementData(true);
//         const res = await enhancementServiceCghs.getEnhancementData(
//           patients?.fetchBasicDetails?.casesResponse?.id,
//           patients?.fetchBasicDetails?.visitInfoResponse?.id,
//           patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
//         );
//         if (res && Array.isArray(res)) {
//           setEnhancementData(res);
//         }
//         setIsFetchingEnhancementData(false);
//       }
//     } catch (err) {
//       setIsFetchingEnhancementData(false);
//       errorMessage("Please, Try again later");
//     }
//   };

  const fetchData = async () => {
      try {
        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          setIsFetchingEnhancementData(true);
          const res: any = await fetchEnhancementDataServiceCghs(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.visitInfoResponse?.id
          );
          if (res && Array.isArray(res)) {
          setEnhancementData(res);
        }
          setIsFetchingEnhancementData(false);
        }
        // Fetch portal meta data
      } catch (error: any) {
        errorMessage(error.message || "Please, Try again later");
        setIsFetchingEnhancementData(false);
      }
    };

  useEffect(() => {
    fetchData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    viewEnhancement
  ]);

  return (
    <div>
      <ViewEnhancementCghs
        viewEnhancement={viewEnhancement}
        closeViewAddedEnhancement={closeViewAddedEnhancement}
        handleOpen={handleOpen}
        isFetchingEnhancementData={isFetchingEnhancementData}
        enhancementsList={enhancementData}
      />

      <ViewEnhancementDocumentCghs
        handleCancel={handleCancelPreview}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        clickedActiveTab={clickedActiveTab}
      />
    </div>
  );
};

export default ViewEnhancementContainerCghs;
